module.exports = __webpack_public_path__ + "img/36_45.d1b57868.png";